/**
 * PageHero Component
 *
 * Compact glass band rendered at the top of every traveler page.
 * Provides a unified pirate-themed page header with:
 *   - Optional eyebrow tag (small uppercase brass label)
 *   - IM Fell English page title
 *   - Optional subtitle (Montserrat)
 *   - Optional right-aligned actions slot
 *
 * Designed to sit directly inside <main>, with PageTabs and
 * GlassSection components stacked below it.
 *
 * Usage:
 *   <PageHero
 *     eyebrow="Browse the Cove"
 *     title="Island Businesses"
 *     subtitle="Discover member-owned shops across the USVI"
 *     actions={<Button>Add Listing</Button>}
 *   />
 */

import React from 'react';
import './PageHero.css';

export function PageHero({
  eyebrow,
  title,
  subtitle,
  actions,
  align = 'left',
  className = '',
  ...rest
}) {
  const cls = [
    'page-hero',
    `page-hero--align-${align}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <header className={cls} {...rest}>
      <div className="page-hero__inner">
        <div className="page-hero__text">
          {eyebrow && <span className="page-hero__eyebrow">{eyebrow}</span>}
          {title && <h1 className="page-hero__title">{title}</h1>}
          {subtitle && <p className="page-hero__subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-hero__actions">{actions}</div>}
      </div>
    </header>
  );
}

export default PageHero;
